import { useCallback, useMemo, useState } from 'react'

export const useModal = <T = boolean>(initialValue: T = false as T): UseModalResult<T, (value?: T) => void, () => void> => {
  const [opened, setOpened] = useState(initialValue)
  const open = useCallback((newValue: T = true as T) => setOpened(newValue), [])
  const close = useCallback(() => setOpened(initialValue), [initialValue])

  return useMemo(() => {
    const result = [opened, open, close] as UseModalResult<T, typeof open, typeof close>

    result.opened = opened
    result.open = open
    result.close = close

    return result
  }, [opened, open, close])
}
type UseModalResult<T, O extends (value?: T) => void = (value?: T) => void, C extends () => void = () => void> = [T, O, C] & {
  opened: T
  open: O
  close: C
}
